module.exports = __webpack_public_path__ + "static/media/paypal_pay.5bf7c275.svg";